export default __webpack_public_path__ + "static/media/ceo--mobile.00bf7d13.png";